import { Link } from "react-router-dom"
import { useUserState } from "../context"
import "./Menu.css"

export const Menu = (props) => {
    const {username, level} = useUserState()

    


    return(
        <div className="LeftMenu">
            <div className="userArea">
                <div className="username"><b>{username}</b>님 환영홥니다.</div>
                <Link to="/logout" ><button className="logoutButton">Logout</button></Link>
            </div>

            <div className="menulist">
                <ul>
                    <li>카카오톡제안</li>
                    <li>카카오톡제안</li>
                    {( level === "admin" )? <Link to="/user"><li>사용자관리</li></Link> : null }
                </ul>
            </div>
        </div>
    )
}